"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var AddressCard = function (_a) {
    var _b;
    var address = _a.address;
    var line1 = address.line1 ? address.line1.trim() : "";
    var line2 = address.line2 ? address.line2.trim() : "";
    var line1And2 = line1 + line2;
    var formattedLine1And2 = line1And2 ? line1And2 + ", " : "";
    var city = address.city ? address.city.trim() + ", " : "";
    var state = address.state ? address.state.trim() + " " : "";
    var postal_code = (_b = address.postal_code) === null || _b === void 0 ? void 0 : _b.trim();
    return (React.createElement("div", { className: "Grid" },
        React.createElement("div", { className: "Grid-cell u-sizeFit" },
            React.createElement(teamsnap_ui_1.Icon, { name: "location", mods: "u-spaceRightSm u-colorGrey" })),
        React.createElement("div", { className: "Grid-cell u-sizeFill" },
            formattedLine1And2,
            city,
            state,
            postal_code)));
};
exports.default = AddressCard;
//# sourceMappingURL=address-info.js.map